export default process.env.VUE_APP_RESERVATIONS_ENABLED === 'true' ? [{
  routeName: 'reservations',
  text: 'leftSideMenu.reservations',
  icon: 'calendar',
  roles: ['operator', 'admin'],
  permissions: [],
  alwaysVisible: true,
  place: 'top',
  paths: ['reservations'],
  group: 'restaurant',
  routeNames: ['reservations'],
}] : [];
